import {
  LOAD_ARCHIVE_TASKS,
  LOAD_ARCHIVE_QUOTES,
  LOAD_ARCHIVE_TASKS_FAILED,
  LOAD_ARCHIVE_QUOTES_FAILED,
  REOPEN_ARCHIVE_TASK,
  REMOVE_TASK_FROM_ARCHIVE,
  REMOVE_QUOTE_FROM_ARCHIVE,
} from '../../actions/archive';

export default function archive(state = {}, action) {
  switch (action.type) {
    case LOAD_ARCHIVE_TASKS:
      return Object.assign({}, state, action.payload);
    case LOAD_ARCHIVE_QUOTES:
      return Object.assign({}, state, action.payload);
    case REMOVE_TASK_FROM_ARCHIVE:
      for (let i = 0; i < state.tasks.list.length; i++) {
        if (state.tasks.list[i].task_id == action.payload.id) {
          state.tasks.list.splice(i, 1);
        }
      }
    case REMOVE_QUOTE_FROM_ARCHIVE:
      for (let i = 0; i < state.quotes.list.length; i++) {
        if (state.quotes.list[i].id == action.payload.id) {
          state.quotes.list.splice(i, 1);
        }
      }
    case LOAD_ARCHIVE_TASKS_FAILED:
      return Object.assign({}, state, action.payload);
    case LOAD_ARCHIVE_QUOTES_FAILED:
      return Object.assign({}, state, action.payload);
    case REOPEN_ARCHIVE_TASK:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/archive/index.js